import React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import yearData from "../../constants/yearData";
import monthData from "../../constants/monthData";

const DealerYearMonthSelector = ({ stores, filterVal, setFilterVal, loadData }) => {

    const handleChange = (field, event) => {
        if (field === 'store_name') {
            setFilterVal({ ...filterVal, [field]: event.target.value, 'store_id': Object.keys(stores).find(key => stores[key] === event.target.value) });
        } else {
            setFilterVal({ ...filterVal, [field]: event.target.value });
        }
    };

    return (
        <div className="row" >
            <div className="col-12 col-md-4  col-xl-2 ">
                <Box
                    sx={{ minWidth: 120 }}
                    style={{ width: "100%",marginTop: ".7em" }}
                >
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label"  className="pt-2">
                            {filterVal.division === 'FFUN Financial' ? 'Company' : 'Dealer'}
                        </InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={filterVal.store_name}
                            label="Dealer"
                            onChange={(e) => handleChange('store_name', e)}
                        >
                            {Object.values(stores).map((child) => (
                                <MenuItem value={child}>{child}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </div>
            <div className="col-12 col-md-2">
                <Box
                    style={{ display: "inline-block", width: "100%",marginTop: ".7em" }}
                >
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label" className="pt-2">Year</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={filterVal.year}
                            label="Year"
                            onChange={(e) => handleChange('year', e)}
                        >
                            {yearData.map(child => (
                                <MenuItem value={child}>{child}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </div>
            <div className="col-12 col-md-2">
                <Box
                    style={{ display: "inline-block", width: "100%",marginTop: ".7em" }}
                >
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label"  className="pt-2">Month</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Months"
                            value={filterVal.month}
                            onChange={(e) => handleChange('month', e)}
                        >
                            {monthData.map((child, index) => (
                                <MenuItem value={child} key={index}>{child}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </div>
            <div className="col">
                <button className="p-2 mt-2 btn btn-secondary" type="submit"
                    onClick={() => {
                        loadData()
                    }}
                >
                    Show Details
                </button>
            </div>
        </div>
    )
}

export default DealerYearMonthSelector